import {observable} from "mobx";

export const socketStore = observable({
    isConnected: false,
    socket: {} as WebSocket,
    reactions: new Map<string, Array<Function>>(),
    async open(url: string, typeNotify: string, openCallback?: () => any, closeCallback?: (event: CloseEvent) => any, errorCallback?: (err: Event) => any) {
        this.socket = new WebSocket('ws://localhost:5005/ws');
        this.socket.onopen = () => {
            if (openCallback)
                openCallback();
            socketStore.send(typeNotify);
            console.log('Socket open');
        };
        this.socket.onmessage = event => {
            const message = JSON.stringify(event.data).replaceAll("\\u0000", "");
            if (Notification.permission == 'granted') {
                navigator.serviceWorker.getRegistration().then((reg) => {
                    var options = {
                        body: message,
                        icon: 'favicon.png',
                        vibrate: [100, 50, 100],
                        data: {
                          dateOfArrival: Date.now(),
                          primaryKey: 1
                        }
                      };
                    reg?.showNotification("Updater", options);
                });
            }
        };
        this.socket.onclose = (e) => {
            if (closeCallback)
                closeCallback(e);
            console.log('Socket close') 
        };
        this.socket.onerror = (err) => {
            if (errorCallback)
                errorCallback(err);
            this.socket.close();
        };
    },
    close() {
        this.socket.close();
    },
    send(value: string) {
        if (this.socket.readyState === this.socket.OPEN)
            this.socket.send(value);
    },
});
